import { ROUTES } from '@/constants/app';

export interface CapacitesNavigationClient {
  aDesEntreprises: boolean;
  peutVoirAbsences: boolean;
  peutVoirApprobations: boolean;
  bdeseOuverte: boolean;
  folderUuid: string | null;
}

/** Destinations strictement utiles à cet acteur, dans leur ordre d'affichage. */
export function destinationsNavigationClient(
  capacites: CapacitesNavigationClient
): string[] {
  return [
    ...(capacites.aDesEntreprises ? ['/mon-entreprise'] : []),
    ...(capacites.peutVoirAbsences ? [ROUTES.SIRH.MY_LEAVE] : []),
    ...(capacites.peutVoirApprobations ? [ROUTES.SIRH.APPROVALS] : []),
    ...(capacites.bdeseOuverte && capacites.folderUuid
      ? [`/bdese/${capacites.folderUuid}`]
      : []),
  ];
}

export function destinationClientParDefaut(
  capacites: CapacitesNavigationClient
): string {
  return destinationsNavigationClient(capacites)[0] ?? '/';
}

/**
 * Une barre latérale personnalisée ne suffit pas : une ancienne URL, un favori
 * ou le bouton « précédent » ne doivent jamais remonter un écran du cabinet à
 * une personne qui travaille chez le client. Cette fonction protège donc aussi
 * l'accès direct, avant que la page visée ne lance ses propres appels API.
 */
export function destinationEstAutoriseePourClient(
  chemin: string,
  capacites: CapacitesNavigationClient
): boolean {
  // Ces écrans sont personnels et restent utiles quel que soit le rôle exercé
  // dans l'entreprise. Ils n'exposent pas le territoire de travail du cabinet.
  // L'aide de l'assistant (/aide/assistant) n'en fait PAS partie : une
  // entreprise cliente n'a pas l'assistant, elle n'a pas besoin de son mode
  // d'emploi — et son lien « Ouvrir l'assistant » la renverrait sur sa page
  // d'entrée (verdict qualité n°2 du 12/09/2026).
  if (['/notifications', '/profile', '/settings', '/support'].includes(chemin)) {
    return true;
  }

  if (chemin === '/mon-entreprise') return capacites.aDesEntreprises;
  if (chemin.startsWith('/mon-entreprise/')) {
    return capacites.aDesEntreprises;
  }

  if (chemin === ROUTES.SIRH.APPROVALS) {
    return capacites.peutVoirApprobations;
  }
  if (chemin === ROUTES.SIRH.MY_LEAVE) {
    return capacites.peutVoirAbsences;
  }

  if (capacites.bdeseOuverte && capacites.folderUuid) {
    const racineBdese = `/bdese/${capacites.folderUuid}`;
    if (chemin === racineBdese || chemin.startsWith(`${racineBdese}/`)) {
      return true;
    }
  }

  return false;
}
